<p [ngClass]="getAllInnerClasses()">{{ block().textContent }}</p>
